// src/pages/Login/styles.js

import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh);
  width: 100%;
  display: flex;
  position: relative;

  @media (max-width: 900px) {
    display: block;
  }
`;

export const Div = styled.div``;
export const FloatingButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #0C2B6E; /* Cor principal */
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 9999;

  &:hover {
    background-color: #133ea5;
    transform: scale(1.1);
  }

  svg {
    pointer-events: none;
  }
`;
export const Footer = styled.footer`
  background-color: #f8f9fa;
  padding: 10px;
  text-align: center;
  font-size: 14px;
  color: #6c757d;
  border-top: 1px solid #ddd;

  a {
    color: #007bff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
export const LogoCanto = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 70px;
 @media (max-width: 800px) {
  width: 60px;
  max-width: 180px;
}

@media (max-width: 400px) {
  width: 55px;
  max-width: 150px;
}

@media (max-width: 355px) {
  width: 50px;
  max-width: 130px;
}

`;

export const LeftDiv = styled.div`
  flex: 2;
  height: 100%;
  background: url(${(props) => props.background});
  background-size: 100%;
  padding: 100px;
  
  position: relative;

  h1 {
    position: absolute;
    width: calc(100% - 200px);
    height: 150px;
    left: 100px;
    bottom: 100px;
    font-family: 'Raleway', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 50px;
    line-height: 50px;
    color: #FFF;
    text-shadow: -2px 2px 8px rgba(0, 0, 0, 0.25);
  }

  @media (max-width: 900px) {
    padding: 20px;
    height: 300px;
    background-size: 100%;

    h1 {
      width: calc(100% - 100px);
      left: 50px;
      bottom: 50px;
      font-size: 30px;
      line-height: 30px;
    }
  }

  @media (max-width: 470px) {
    background-size: auto 100%;
    height: 400px;

    h1 {
      top: 200px;
      font-size: 28px;
  
    }
  }
`;

export const RightDiv = styled.div`
  background: #FFF;
  text-align: center;
  flex: 1;
  height: 100%;
  padding: 100px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    color: #0C2B6E;
    font-family: 'Raleway', sans-serif;
    margin: 20px 0;
    font-weight: 700;
  }

 

  @media (max-width: 900px) {
    padding: 40px;
    height: 800px;
    h1 {
      margin: 5px 0;
    }
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #0C2B6E;
`;


